import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bd0a60e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-5 text-sm" }
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "info-grid" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "input-form-label" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "card"
}
const _hoisted_9 = { class: "divide-y divide-gray-100" }
const _hoisted_10 = { class: "flex items-center gap-3" }
const _hoisted_11 = { class: "font-medium text-gray-700" }
const _hoisted_12 = {
  key: 0,
  class: "mt-3 ml-7 rounded-lg border border-gray-100 bg-gray-50 px-4 py-3"
}
const _hoisted_13 = { class: "flex items-center gap-3" }
const _hoisted_14 = { class: "text-gray-600" }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_17 = ["aria-expanded", "disabled", "onClick"]
const _hoisted_18 = { class: "block text-base font-semibold text-gray-800" }
const _hoisted_19 = { class: "mt-1 block text-xs text-gray-500" }
const _hoisted_20 = { class: "space-y-5" }
const _hoisted_21 = { class: "check-grid" }
const _hoisted_22 = {
  key: 3,
  class: "info-grid"
}
const _hoisted_23 = { class: "mb-3 text-sm font-medium text-gray-700" }
const _hoisted_24 = { class: "check-grid" }
const _hoisted_25 = {
  key: 4,
  class: "rounded-xl border border-dashed border-gray-200 bg-gray-50 p-5"
}
const _hoisted_26 = { class: "mb-4 text-sm font-semibold text-gray-700" }
const _hoisted_27 = { class: "info-grid" }
const _hoisted_28 = {
  key: 1,
  class: "card text-gray-500"
}
const _hoisted_29 = {
  key: 3,
  class: "card"
}
const _hoisted_30 = { class: "info-grid" }
const _hoisted_31 = {
  key: 4,
  class: "card"
}
const _hoisted_32 = { class: "info-grid" }
const _hoisted_33 = { class: "md:col-span-2" }
const _hoisted_34 = { class: "input-form-label" }
const _hoisted_35 = { class: "mt-1 text-gray-800" }
const _hoisted_36 = { class: "mt-1 text-xs text-gray-500" }

import {
  computed,
  defineComponent,
  h,
  PropType,
  ref,
} from "vue";

import StatusLabel from "@/components/common/StatusLabel.vue";

import { t } from "@/i18n";

import { EEntityScope } from "@/types/common/entityApproval/EntityApproval";

import DocumentConstructor from "@/types/documents/documentConstructor/DocumentConstructor";
import Params from "@/types/documents/documentConstructor/Params";
import ParamsConfig from "@/types/documents/documentConstructor/config/ParamsConfig";
import Process from "@/types/documents/documentConstructor/Process";
import EsedoConfig from "@/types/documents/documentConstructor/EsedoConfig";
import { formatDateTime } from "@/utils/date";
import { ChevronDownIcon } from "@heroicons/vue/outline";

type PayloadSection =
  | "all"
  | "overview"
  | "parameters"
  | "processes"
  | "access"
  | "integration";


export default /*#__PURE__*/_defineComponent({
  props: {
    payload: null,
    section: null,
    collapsibleProcesses: null,
    compactOverview: null
  },
  setup(__props: any) {

const props = __props as {
  payload: Record<string, unknown> | DocumentConstructor;
  section?: PayloadSection;
  collapsibleProcesses?: boolean;
  compactOverview?: boolean;
}



const scopeEnum = EEntityScope;

const data = computed(() => props.payload as DocumentConstructor);

const processes = computed((): Process[] => {
  const list = data.value.process;

  return Array.isArray(list) ? list : [];
});

const expandedProcessIndexes = ref<number[]>([0]);

const showSection = (section: Exclude<PayloadSection, "all">) => {
  return !props.section || props.section === "all" || props.section === section;
};

const isProcessExpanded = (index: number) => {
  return (
    !props.collapsibleProcesses || expandedProcessIndexes.value.includes(index)
  );
};

const toggleProcess = (index: number) => {
  if (!props.collapsibleProcesses) return;

  expandedProcessIndexes.value = expandedProcessIndexes.value.includes(index)
    ? expandedProcessIndexes.value.filter((item) => item !== index)
    : [...expandedProcessIndexes.value, index];
};

const processTitle = (process: Process) => {
  if (process.processMode === "FREE") {
    return t("docConstructorForm.processKindFree");
  }
  return process.templateName || t("docConstructorForm.processKindTemplate");
};

const hasScope = computed(() => {
  return data.value.viewScope != null || data.value.editScope != null;
});

const esedoConfig = computed((): EsedoConfig | undefined => {
  return (data.value.params as Params | undefined)?.esedoConfig;
});

const counterpartyModeLabel = (mode?: string) => {
  const labels: Record<string, string> = {
    NOT_USED: t("esedo.modeNotUsed"),
    OPTIONAL: t("esedo.modeOptional"),
    REQUIRED: t("esedo.modeRequired"),
  };
  return mode ? labels[mode] ?? mode : "—";
};

const processModeLabel = (mode?: string) => {
  if (mode === "FREE") return t("docConstructorForm.processKindFree");
  if (mode === "TEMPLATE" || !mode) {
    return t("docConstructorForm.processKindTemplate");
  }
  return mode;
};

const approvalStatusLabel = (status?: string | null) => {
  const labels: Record<string, string> = {
    WAITING: t("approval.pending"),
    ACTIVE: t("status.active"),
    DEACTIVATED: t("status.disabled"),
  };
  return status ? labels[status] || status : "—";
};

const resolveDocumentTypeName = (id?: string | null) => {
  if (id == null) return "—";
  const cfg = esedoConfig.value;
  return cfg?.documentType ?? String(id);
};

const resolveQuestionNatureName = (id?: string | null) => {
  if (id == null) return "—";
  const cfg = esedoConfig.value;
  return cfg?.questionNature ?? String(id);
};

const paramOrder = [
  "title",
  "nomenclature",
  "mainFile",
  "subFile",
  "description",
  "price",
] as const;

const paramLabels: Record<string, string> = {
  title: t("docForm.theme"),
  nomenclature: t("docForm.nomenclature"),
  mainFile: t("docConstructorForm.mainFile"),
  subFile: t("docConstructorForm.extraFiles"),
  description: t("docConstructorForm.paramDescription"),
  price: t("docConstructorForm.paramPrice"),
};

const paramLabel = (key: string) => {
  return paramLabels[key] ?? key;
};

const paramConfig = (key: string): ParamsConfig | undefined => {
  const params = data.value.params as Params | undefined;

  return params?.[key as keyof Params];
};

const scopeLabel = (scope?: string) => {
  const labels: Record<string, string> = {
    [EEntityScope.PRIVATE]: t("entityScope.private"),
    [EEntityScope.UNIT]: t("entityScope.unit"),
    [EEntityScope.MULTI_UNIT]: t("entityScope.multiUnit"),
    [EEntityScope.ALL]: t("entityScope.all"),
  };

  return scope ? labels[scope] ?? scope : "—";
};

const receiverTypeLabel = (type: string) => {
  const labels: Record<string, string> = {
    USER: t("docConstructorForm.receiverUser"),
    STRUCTURE: t("docConstructorForm.receiverStructure"),
  };

  return labels[type] ?? type;
};

const filterTypeLabel = (type: string) => {
  const labels: Record<string, string> = {
    SAME_ORIGIN: t("docConstructorForm.sameOrigin"),
    ALL: t("docConstructorForm.allCompanies"),
    INDIVIDUAL: t("docConstructorForm.individualCompany"),
    IN_CREATOR_COMPANY: t("docConstructorForm.creatorCompany"),
    INDIVIDUAL_WITH_CHILDS: t("docConstructorForm.departmentWithChildren"),
  };

  return labels[type] ?? type;
};

const redirectFilterTypeLabel = (type: string) => {
  const labels: Record<string, string> = {
    SAME_ORIGIN: t("docConstructorForm.creatorCompany"),
    ALL: t("docConstructorForm.allCompanies"),
    INDIVIDUAL: t("docConstructorForm.individualCompany"),
  };

  return labels[type] ?? type;
};

const formatIds = (ids: string[] | null | undefined) => {
  return ids?.length ? ids.join(", ") : "—";
};

const formatNames = (
  names: string[] | null | undefined,
  ids: string[] | null | undefined
) => {
  return names?.length ? names.join(", ") : formatIds(ids);
};

const showReceiverCompanies = (proc: Process) => {
  const ft = proc.receiverTypeFilter?.companyFilterType;

  return (
    ft === "INDIVIDUAL" ||
    (proc.receiverType === "USER" &&
      (ft === "INDIVIDUAL" || ft === "INDIVIDUAL_WITH_CHILDS"))
  );
};

const ReadonlyCheckbox = defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    return () =>
      h("input", {
        type: "checkbox",
        checked: props.checked,
        disabled: true,
        class: "h-4 w-4 rounded border-gray-300 text-primary-300 opacity-80",
      });
  },
});

const SectionTitle = defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    return () =>
      h(
        "h2",
        {
          class: "mb-5 text-lg font-semibold text-gray-800",
        },
        props.title
      );
  },
});

const InfoItem = defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },

    value: {
      type: [String, Number] as PropType<string | number>,
      default: "—",
    },
  },

  setup(props) {
    return () =>
      h("div", [
        h(
          "span",
          {
            class: "input-form-label text-gray-500",
          },
          props.label
        ),

        h(
          "p",
          {
            class: "mt-1 break-words text-gray-800",
          },
          String(props.value || "—")
        ),
      ]);
  },
});

const CheckItem = defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    return () =>
      h(
        "div",
        {
          class:
            "flex items-center gap-3 rounded-lg border border-gray-100 bg-gray-50 px-4 py-3",
        },
        [
          h(ReadonlyCheckbox, {
            checked: props.checked,
          }),

          h(
            "span",
            {
              class: "text-sm text-gray-700",
            },
            props.label
          ),
        ]
      );
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showSection('overview'))
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(_unref(SectionTitle), {
            title: _unref(t)('entityApproval.constructor.mainInfo')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_3, [
            (!__props.compactOverview)
              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                  key: 0,
                  label: _unref(t)('common.title'),
                  value: _unref(data).name || '—'
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(InfoItem), {
              class: "md:col-span-2",
              label: _unref(t)('docConstructorForm.description'),
              value: _unref(data).description || '—'
            }, null, 8, ["label", "value"]),
            (!__props.compactOverview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("common.status")), 1),
                  _createElementVNode("div", _hoisted_6, [
                    (_unref(data).status)
                      ? (_openBlock(), _createBlock(StatusLabel, {
                          key: 0,
                          label: String(_unref(data).status)
                        }, null, 8, ["label"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, "—"))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('docConstructorView.processCount'),
              value: _unref(processes).length
            }, null, 8, ["label", "value"]),
            (_unref(data).approvalStatus)
              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                  key: 2,
                  label: _unref(t)('docConstructorView.approvalStatus'),
                  value: approvalStatusLabel(_unref(data).approvalStatus)
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            (_unref(data).createdAt)
              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                  key: 3,
                  label: _unref(t)('common.createdAt'),
                  value: _unref(formatDateTime)(_unref(data).createdAt)
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            (_unref(data).updatedAt)
              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                  key: 4,
                  label: _unref(t)('common.updatedAt'),
                  value: _unref(formatDateTime)(_unref(data).updatedAt)
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (showSection('parameters'))
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
          _createVNode(_unref(SectionTitle), {
            title: _unref(t)('docConstructorForm.params')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paramOrder), (paramKey) => {
              return (_openBlock(), _createElementBlock("div", {
                key: paramKey,
                class: "py-4"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(ReadonlyCheckbox), {
                    checked: paramConfig(paramKey)?.isSelected
                  }, null, 8, ["checked"]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(paramLabel(paramKey)), 1)
                ]),
                (paramConfig(paramKey)?.isSelected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_unref(ReadonlyCheckbox), {
                          checked: paramConfig(paramKey)?.isRequired
                        }, null, 8, ["checked"]),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("docConstructorForm.filled")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (showSection('processes'))
      ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
          _createVNode(_unref(SectionTitle), {
            title: _unref(t)('docConstructorForm.process')
          }, null, 8, ["title"]),
          (_unref(processes).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processes), (proc, index) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: proc.processGuid || index,
                    class: "card"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["flex items-center justify-between", {
              'w-full cursor-pointer text-left': __props.collapsibleProcesses,
              'w-full cursor-default text-left': !__props.collapsibleProcesses,
              'mb-5 border-b border-gray-100 pb-4': isProcessExpanded(index),
            }]),
                      "aria-expanded": isProcessExpanded(index),
                      disabled: !__props.collapsibleProcesses,
                      onClick: ($event: any) => (toggleProcess(index))
                    }, [
                      _createElementVNode("span", null, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(index + 1) + ". " + _toDisplayString(processTitle(proc)), 1),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(processModeLabel(proc.processMode)), 1)
                      ]),
                      (__props.collapsibleProcesses)
                        ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                            key: 0,
                            class: _normalizeClass(["h-5 w-5 flex-none text-gray-500 transition-transform", { 'rotate-180': isProcessExpanded(index) }])
                          }, null, 8, ["class"]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_17),
                    _withDirectives(_createElementVNode("div", _hoisted_20, [
                      _createVNode(_unref(InfoItem), {
                        label: _unref(t)('docConstructorForm.processKind'),
                        value: processModeLabel(proc.processMode)
                      }, null, 8, ["label", "value"]),
                      (proc.processMode !== 'FREE')
                        ? (_openBlock(), _createBlock(_unref(InfoItem), {
                            key: 0,
                            label: _unref(t)('docConstructorView.templateId'),
                            value: proc.templateName || String(proc.templateId || '—')
                          }, null, 8, ["label", "value"]))
                        : (_openBlock(), _createBlock(_unref(InfoItem), {
                            key: 1,
                            label: _unref(t)('docConstructorView.allowedTemplates'),
                            value: formatIds(proc.freeTemplateIds)
                          }, null, 8, ["label", "value"])),
                      (proc.deadlineDays != null)
                        ? (_openBlock(), _createBlock(_unref(InfoItem), {
                            key: 2,
                            label: _unref(t)('docConstructorView.deadlineDays'),
                            value: proc.deadlineDays
                          }, null, 8, ["label", "value"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_unref(CheckItem), {
                          checked: proc.isRequired,
                          label: _unref(t)('docConstructorForm.processKindRequired')
                        }, null, 8, ["checked", "label"]),
                        _createVNode(_unref(CheckItem), {
                          checked: proc.allowParallel,
                          label: _unref(t)('docConstructorView.parallelExecution')
                        }, null, 8, ["checked", "label"])
                      ]),
                      (proc.receiverType)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_unref(InfoItem), {
                              label: _unref(t)('docConstructorForm.receiverType'),
                              value: receiverTypeLabel(proc.receiverType)
                            }, null, 8, ["label", "value"]),
                            (proc.receiverTypeFilter?.companyFilterType)
                              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                                  key: 0,
                                  label: _unref(t)('docConstructorForm.filterType'),
                                  value: 
                  filterTypeLabel(proc.receiverTypeFilter.companyFilterType)
                
                                }, null, 8, ["label", "value"]))
                              : _createCommentVNode("", true),
                            (
                  showReceiverCompanies(proc) &&
                  proc.receiverTypeFilter?.companies?.length
                )
                              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                                  key: 1,
                                  label: _unref(t)('docConstructorForm.companies'),
                                  value: 
                  formatNames(
                    proc.receiverTypeFilter.companyNames,
                    proc.receiverTypeFilter.companies
                  )
                
                                }, null, 8, ["label", "value"]))
                              : _createCommentVNode("", true),
                            (
                  proc.receiverType === 'USER' &&
                  proc.receiverTypeFilter?.jobs?.length
                )
                              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                                  key: 2,
                                  label: _unref(t)('docConstructorForm.job'),
                                  value: 
                  formatNames(
                    proc.receiverTypeFilter.jobNames,
                    proc.receiverTypeFilter.jobs
                  )
                
                                }, null, 8, ["label", "value"]))
                              : _createCommentVNode("", true),
                            (
                  proc.receiverType === 'USER' &&
                  proc.receiverTypeFilter?.users?.length
                )
                              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                                  key: 3,
                                  label: _unref(t)('docConstructorForm.users'),
                                  value: 
                  formatNames(
                    proc.receiverTypeFilter.userNames,
                    proc.receiverTypeFilter.users
                  )
                
                                }, null, 8, ["label", "value"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)("common.actions")), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_unref(CheckItem), {
                            checked: proc.canRework,
                            label: _unref(t)('docConstructorForm.rework')
                          }, null, 8, ["checked", "label"]),
                          _createVNode(_unref(CheckItem), {
                            checked: proc.canDeny,
                            label: _unref(t)('docConstructorForm.deny')
                          }, null, 8, ["checked", "label"]),
                          _createVNode(_unref(CheckItem), {
                            checked: proc.canAnswer,
                            label: _unref(t)('docConstructorForm.answer')
                          }, null, 8, ["checked", "label"]),
                          _createVNode(_unref(CheckItem), {
                            checked: proc.canReview,
                            label: _unref(t)('docConstructorForm.review')
                          }, null, 8, ["checked", "label"]),
                          _createVNode(_unref(CheckItem), {
                            checked: proc.canRedirect,
                            label: _unref(t)('docConstructorForm.transfer')
                          }, null, 8, ["checked", "label"])
                        ])
                      ]),
                      (proc.canRedirect && proc.redirectReceiverTypeFilter)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("h4", _hoisted_26, _toDisplayString(_unref(t)("docConstructorForm.transfer")), 1),
                            _createElementVNode("div", _hoisted_27, [
                              (proc.redirectReceiverTypeFilter.companyFilterType)
                                ? (_openBlock(), _createBlock(_unref(InfoItem), {
                                    key: 0,
                                    label: _unref(t)('docConstructorForm.filteringType'),
                                    value: 
                    redirectFilterTypeLabel(
                      proc.redirectReceiverTypeFilter.companyFilterType
                    )
                  
                                  }, null, 8, ["label", "value"]))
                                : _createCommentVNode("", true),
                              (proc.redirectReceiverTypeFilter.companies?.length)
                                ? (_openBlock(), _createBlock(_unref(InfoItem), {
                                    key: 1,
                                    label: _unref(t)('docConstructorForm.companies'),
                                    value: 
                    formatNames(
                      proc.redirectReceiverTypeFilter.companyNames,
                      proc.redirectReceiverTypeFilter.companies
                    )
                  
                                  }, null, 8, ["label", "value"]))
                                : _createCommentVNode("", true),
                              (proc.redirectReceiverTypeFilter.jobs?.length)
                                ? (_openBlock(), _createBlock(_unref(InfoItem), {
                                    key: 2,
                                    label: _unref(t)('docConstructorForm.job'),
                                    value: 
                    formatNames(
                      proc.redirectReceiverTypeFilter.jobNames,
                      proc.redirectReceiverTypeFilter.jobs
                    )
                  
                                  }, null, 8, ["label", "value"]))
                                : _createCommentVNode("", true),
                              (proc.redirectReceiverTypeFilter.users?.length)
                                ? (_openBlock(), _createBlock(_unref(InfoItem), {
                                    key: 3,
                                    label: _unref(t)('docConstructorForm.users'),
                                    value: 
                    formatNames(
                      proc.redirectReceiverTypeFilter.userNames,
                      proc.redirectReceiverTypeFilter.users
                    )
                  
                                  }, null, 8, ["label", "value"]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, isProcessExpanded(index)]
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(t)("common.noData")), 1))
        ]))
      : _createCommentVNode("", true),
    (showSection('integration') && _unref(esedoConfig)?.enabled)
      ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
          _createVNode(_unref(SectionTitle), {
            title: _unref(t)('esedo.title')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('esedo.documentType'),
              value: resolveDocumentTypeName(_unref(esedoConfig).documentTypeId)
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('esedo.questionNature'),
              value: resolveQuestionNatureName(_unref(esedoConfig).questionNatureId)
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('esedo.counterpartyMode'),
              value: counterpartyModeLabel(_unref(esedoConfig).counterpartySelectionMode)
            }, null, 8, ["label", "value"])
          ])
        ]))
      : _createCommentVNode("", true),
    (showSection('access') && _unref(hasScope))
      ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
          _createVNode(_unref(SectionTitle), {
            title: _unref(t)('entityScope.title')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('entityScope.viewScope'),
              value: scopeLabel(_unref(data).viewScope)
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('entityScope.editScope'),
              value: scopeLabel(_unref(data).editScope)
            }, null, 8, ["label", "value"]),
            (_unref(data).viewScope === _unref(scopeEnum).MULTI_UNIT)
              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                  key: 0,
                  label: _unref(t)('entityScope.viewDirectorates'),
                  value: formatIds(_unref(data).viewDirectorateIds)
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            (_unref(data).editScope === _unref(scopeEnum).MULTI_UNIT)
              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                  key: 1,
                  label: _unref(t)('entityScope.editDirectorates'),
                  value: formatIds(_unref(data).editDirectorateIds)
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(t)("entityScope.coordinator")), 1),
              _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(data).coordinatorName ||
              (_unref(data).coordinatorId != null
                ? _unref(data).coordinatorId
                : _unref(t)("entityScope.coordinatorAny")
              )), 1),
              _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(t)("entityScope.coordinatorHint")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})